import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserLayoutComponent } from './overview/layout/users-layout.component';
import { EntityPermissionGuard, AskToDeactivateGuard } from '@kpd/framework-ngx';
import { UserDetailsComponent } from './detail/user-details.component';
import { EntityResolverTypes } from '../app.entity.resolvers';
import { ChangePasswordComponent } from '../shared/components/change-password/change-password.component';
import { CurrentUserEntityResolver } from '../shared/components/entity-resolvers/current-user.entity-resolver';
import { titleFunction } from 'app/app-routing.module';

const routes: Routes = [
  {
    path: 'users',
    component: UserLayoutComponent,
    data: {
      routeName: 'users',
      routePermissionPrefix: 'User',
      breadCrumbData: { titleFunc: titleFunction('Users') },
    },
    canActivate: [EntityPermissionGuard],
  },
  {
    path: 'users/detail/:id',
    component: UserDetailsComponent,
    data: {
      routeName: 'userDetail',
      routeParentName: 'users',
      routePermissionPrefix: 'User',
      routePermissionPrefixTabs: { licenses: 'User.License', roles: 'User.Role' },
      routePermissionId: 'id',
      breadCrumbData: {
        titleResolverType: EntityResolverTypes.user,
        titleEntityIdKeys: 'id',
      },
      pageTitlePrefixFunc: titleFunction('User'),
    },
    canActivate: [EntityPermissionGuard],
    canDeactivate: [AskToDeactivateGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'me',
    component: UserDetailsComponent,
    data: {
      routeName: 'profile',
      breadCrumbData: { titleFunc: titleFunction('Profile') },
    },
    canActivate: [EntityPermissionGuard],
    canDeactivate: [AskToDeactivateGuard],
    resolve: {
      currentUser: CurrentUserEntityResolver,
    },
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'me/changepassword',
    component: ChangePasswordComponent,
    data: {
      routeName: 'changepassword',
      routeParentName: 'profile',
      routePermissionPrefix: 'ChangePassword',
      breadCrumbData: { titleFunc: titleFunction('Change password') },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsersRoutingModule {}
